// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.word-search {
  width: 100%;
  max-width: 900px;
  box-sizing: border-box;
  margin: 16px 0 24px;
  padding: 22px 24px;
  border: 1px solid #d7e4e5;
  border-radius: 14px;
  background: linear-gradient(135deg, #f1fbf8 0%, #fffaf0 100%);
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.08);
}

.word-search-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.word-search.is-collapsed .word-search-header {
  margin-bottom: 0;
}

.word-search-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.word-search-bookmarks-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #b8d7d2;
  border-radius: 8px;
  padding: 7px 10px;
  background: #fff;
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}

.word-search-bookmarks-link:hover {
  background: #dff3ee;
}

.word-search-eyebrow {
  margin: 0 0 4px;
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.word-search h2,
.word-search h3 {
  margin: 0;
  color: #183b3b;
}

.word-search h2 {
  font-size: 24px;
}

.word-search-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid #99d5ca;
  border-radius: 10px;
  color: #0f766e;
  font-size: 19px;
  font-weight: 700;
  transform: rotate(-5deg);
}

.word-search-mark.multilingual {
  width: auto;
  min-width: 96px;
  gap: 4px;
  padding: 0 7px;
  font-size: 16px;
  transform: rotate(-5deg);
}

.word-search-mark.multilingual span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.word-search-toggle {
  border: 1px solid #99d5ca;
  border-radius: 8px;
  padding: 7px 10px;
  background: #fff;
  color: #0f766e;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.word-search-toggle:hover {
  background: #dff3ee;
}

.word-search-form {
  display: grid;
  gap: 7px;
}

.word-search-form-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.word-search-label {
  color: #486363;
  font-size: 13px;
  font-weight: 600;
}

.word-search-language-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow: visible;
  flex-wrap: nowrap;
}

.word-search-language-tabs button {
  flex: 1 1 0;
  min-width: 0;
  border: 1px solid #b8d7d2;
  border-radius: 999px;
  padding: 5px 9px;
  background: #fff;
  color: #486363;
  font: inherit;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

.word-search-language-tabs button:hover {
  background: #dff3ee;
}

.word-search-language-tabs button.active {
  border-color: #0f766e;
  background: #0f766e;
  color: #fff;
}

.word-search-controls {
  display: flex;
  gap: 8px;
}

.word-search-controls input {
  min-width: 0;
  flex: 1;
  border: 1px solid #b8d7d2;
  border-radius: 8px;
  padding: 10px 12px;
  color: #183b3b;
  font: inherit;
  background: #fff;
}

.word-search-controls input:focus {
  outline: 2px solid #99d5ca;
  outline-offset: 1px;
}

.word-search-mic {
  width: 42px;
  min-width: 42px;
  border: 1px solid #b8d7d2;
  border-radius: 8px;
  background: #fff;
  color: #0f766e;
  font-size: 16px;
  cursor: pointer;
}

.word-search-mic:hover:not(:disabled),
.word-search-mic.active {
  background: #dff3ee;
}

.word-search-mic.active {
  color: #b42318;
}

.word-search-mic:disabled {
  cursor: wait;
  opacity: 0.7;
}

.word-search-controls button {
  border: none;
  border-radius: 8px;
  padding: 0 16px;
  background: #0f766e;
  color: #fff;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.word-search-controls button:hover:not(:disabled) {
  background: #115e59;
}

.word-search-controls button:disabled {
  cursor: wait;
  opacity: 0.65;
}

.word-search-message {
  margin: 12px 0 0;
  font-size: 14px;
}

.word-search-message.error {
  color: #b42318;
}

.word-search-result {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #d7e4e5;
}

.word-search-result-heading {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 12px;
}

.word-search-result h3 {
  font-size: 28px;
  text-transform: capitalize;
}

.word-search-word-line,
.word-search-text-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.word-search-bookmark {
  border-color: #b8d7d2;
  color: #0f766e;
}

.word-search-bookmark:hover {
  background: #dff3ee;
}

.word-search-text-row {
  align-items: flex-start;
}

.word-search-voice,
.word-search-mini-voice {
  border: 1px solid #b8d7d2;
  border-radius: 999px;
  background: #fff;
  color: #0f766e;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.word-search-voice {
  width: 28px;
  height: 28px;
  font-size: 12px;
}

.word-search-voice.small,
.word-search-mini-voice {
  width: 22px;
  height: 22px;
  min-width: 22px;
  font-size: 10px;
}

.word-search-voice:hover,
.word-search-mini-voice:hover {
  background: #dff3ee;
}

.word-search-result-heading p {
  margin: 4px 0 0;
  color: #6b7e7e;
  font-size: 13px;
}

.word-search-reference {
  color: #0f766e;
  font-size: 13px;
  white-space: nowrap;
}

.word-search-definition {
  margin: 14px 0 8px;
  color: #294646;
  line-height: 1.55;
  flex: 1;
}

.word-search-example {
  margin: 0;
  border-left: 3px solid #99d5ca;
  padding-left: 10px;
  color: #637878;
  font-style: italic;
  flex: 1;
}

.word-search-synonyms {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
  color: #637878;
  font-size: 13px;
}

.word-search-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  padding: 4px 9px;
  background: #dff3ee;
  color: #0f766e;
}

@media (max-width: 520px) {
  .word-search {
    padding: 18px 16px;
  }

  .word-search-controls {
    flex-direction: column;
  }

  .word-search-form-topline {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .word-search-controls button {
    min-height: 40px;
  }

  .word-search-result-heading {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/WordSearch/wordSearch.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".word-search {\n  width: 100%;\n  max-width: 900px;\n  box-sizing: border-box;\n  margin: 16px 0 24px;\n  padding: 22px 24px;\n  border: 1px solid #d7e4e5;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #f1fbf8 0%, #fffaf0 100%);\n  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.08);\n}\n\n.word-search-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.word-search.is-collapsed .word-search-header {\n  margin-bottom: 0;\n}\n\n.word-search-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.word-search-bookmarks-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border: 1px solid #b8d7d2;\n  border-radius: 8px;\n  padding: 7px 10px;\n  background: #fff;\n  color: #0f766e;\n  font-size: 12px;\n  font-weight: 700;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.word-search-bookmarks-link:hover {\n  background: #dff3ee;\n}\n\n.word-search-eyebrow {\n  margin: 0 0 4px;\n  color: #0f766e;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.word-search h2,\n.word-search h3 {\n  margin: 0;\n  color: #183b3b;\n}\n\n.word-search h2 {\n  font-size: 24px;\n}\n\n.word-search-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border: 1px solid #99d5ca;\n  border-radius: 10px;\n  color: #0f766e;\n  font-size: 19px;\n  font-weight: 700;\n  transform: rotate(-5deg);\n}\n\n.word-search-mark.multilingual {\n  width: auto;\n  min-width: 96px;\n  gap: 4px;\n  padding: 0 7px;\n  font-size: 16px;\n  transform: rotate(-5deg);\n}\n\n.word-search-mark.multilingual span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.word-search-toggle {\n  border: 1px solid #99d5ca;\n  border-radius: 8px;\n  padding: 7px 10px;\n  background: #fff;\n  color: #0f766e;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.word-search-toggle:hover {\n  background: #dff3ee;\n}\n\n.word-search-form {\n  display: grid;\n  gap: 7px;\n}\n\n.word-search-form-topline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.word-search-label {\n  color: #486363;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.word-search-language-tabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n  max-width: 100%;\n  overflow: visible;\n  flex-wrap: nowrap;\n}\n\n.word-search-language-tabs button {\n  flex: 1 1 0;\n  min-width: 0;\n  border: 1px solid #b8d7d2;\n  border-radius: 999px;\n  padding: 5px 9px;\n  background: #fff;\n  color: #486363;\n  font: inherit;\n  font-size: 12px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.word-search-language-tabs button:hover {\n  background: #dff3ee;\n}\n\n.word-search-language-tabs button.active {\n  border-color: #0f766e;\n  background: #0f766e;\n  color: #fff;\n}\n\n.word-search-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.word-search-controls input {\n  min-width: 0;\n  flex: 1;\n  border: 1px solid #b8d7d2;\n  border-radius: 8px;\n  padding: 10px 12px;\n  color: #183b3b;\n  font: inherit;\n  background: #fff;\n}\n\n.word-search-controls input:focus {\n  outline: 2px solid #99d5ca;\n  outline-offset: 1px;\n}\n\n.word-search-mic {\n  width: 42px;\n  min-width: 42px;\n  border: 1px solid #b8d7d2;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f766e;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.word-search-mic:hover:not(:disabled),\n.word-search-mic.active {\n  background: #dff3ee;\n}\n\n.word-search-mic.active {\n  color: #b42318;\n}\n\n.word-search-mic:disabled {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n.word-search-controls button {\n  border: none;\n  border-radius: 8px;\n  padding: 0 16px;\n  background: #0f766e;\n  color: #fff;\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.word-search-controls button:hover:not(:disabled) {\n  background: #115e59;\n}\n\n.word-search-controls button:disabled {\n  cursor: wait;\n  opacity: 0.65;\n}\n\n.word-search-message {\n  margin: 12px 0 0;\n  font-size: 14px;\n}\n\n.word-search-message.error {\n  color: #b42318;\n}\n\n.word-search-result {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #d7e4e5;\n}\n\n.word-search-result-heading {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.word-search-result h3 {\n  font-size: 28px;\n  text-transform: capitalize;\n}\n\n.word-search-word-line,\n.word-search-text-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.word-search-bookmark {\n  border-color: #b8d7d2;\n  color: #0f766e;\n}\n\n.word-search-bookmark:hover {\n  background: #dff3ee;\n}\n\n.word-search-text-row {\n  align-items: flex-start;\n}\n\n.word-search-voice,\n.word-search-mini-voice {\n  border: 1px solid #b8d7d2;\n  border-radius: 999px;\n  background: #fff;\n  color: #0f766e;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.word-search-voice {\n  width: 28px;\n  height: 28px;\n  font-size: 12px;\n}\n\n.word-search-voice.small,\n.word-search-mini-voice {\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  font-size: 10px;\n}\n\n.word-search-voice:hover,\n.word-search-mini-voice:hover {\n  background: #dff3ee;\n}\n\n.word-search-result-heading p {\n  margin: 4px 0 0;\n  color: #6b7e7e;\n  font-size: 13px;\n}\n\n.word-search-reference {\n  color: #0f766e;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.word-search-definition {\n  margin: 14px 0 8px;\n  color: #294646;\n  line-height: 1.55;\n  flex: 1;\n}\n\n.word-search-example {\n  margin: 0;\n  border-left: 3px solid #99d5ca;\n  padding-left: 10px;\n  color: #637878;\n  font-style: italic;\n  flex: 1;\n}\n\n.word-search-synonyms {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-top: 14px;\n  color: #637878;\n  font-size: 13px;\n}\n\n.word-search-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border-radius: 999px;\n  padding: 4px 9px;\n  background: #dff3ee;\n  color: #0f766e;\n}\n\n@media (max-width: 520px) {\n  .word-search {\n    padding: 18px 16px;\n  }\n\n  .word-search-controls {\n    flex-direction: column;\n  }\n\n  .word-search-form-topline {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .word-search-controls button {\n    min-height: 40px;\n  }\n\n  .word-search-result-heading {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
